var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPeriodicAverage = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2562 7.79135C23.9276 9.11203 24.3533 10.5851 24.4689 12.1552C24.9355 18.4893 20.1789 24.0023 13.8448 24.4689C7.51067 24.9355 1.99763 20.1789 1.53107 13.8448C1.06451 7.51065 5.8211 1.99761 12.1552 1.53105C14.4993 1.35839 16.7309 1.90104 18.6359 2.97424C18.8699 2.5177 19.201 2.11688 19.6039 1.80095C17.4004 0.498931 14.791 -0.167163 12.045 0.0351C4.88472 0.56252 -0.492297 6.79465 0.0351229 13.955C0.562543 21.1153 6.79467 26.4923 13.955 25.9649C21.1153 25.4374 26.4923 19.2053 25.9649 12.045C25.8271 10.1744 25.3 8.42557 24.4687 6.87189C24.1391 7.25879 23.7267 7.57489 23.2562 7.79135ZM22.7617 6.91623C23.2422 6.71428 23.6438 6.36948 23.9178 5.93846C24.1996 5.49509 24.3463 4.96048 24.3048 4.39628C24.2021 3.00209 22.9886 1.95512 21.5944 2.05782C21.2001 2.08686 20.8337 2.20473 20.5131 2.3904C20.0661 2.64923 19.7085 3.03983 19.4892 3.50521C19.3095 3.88646 19.2228 4.31789 19.2559 4.76817C19.3586 6.16237 20.5721 7.20933 21.9663 7.10664C22.2478 7.0859 22.5152 7.01988 22.7617 6.91623ZM11.8033 14.712L8.63528 19.14L8.79728 19.5H10.7413L12.9913 16.278L15.2413 19.5H17.2033L17.3653 19.14L14.1973 14.712L17.2753 10.41L17.0953 10.05H15.1513L12.9913 13.146L10.8493 10.05H8.90528L8.72528 10.41L11.8033 14.712ZM10.4811 6.81003V8.34003H15.5391V6.81003H10.4811Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPeriodicAverage);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/periodic-average.668afcd4bdf0f787060947662d50e49f.svg";